import { Type } from "@scalar/typebox";
import { ResponseObjectRef } from "../../../schemas/v3.1/strict/ref-definitions.js";
import { reference } from "./reference.js";
const ResponsesObjectSchemaDefinition = Type.Record(
  Type.String(),
  Type.Union([ResponseObjectRef, reference(ResponseObjectRef)])
);
export {
  ResponsesObjectSchemaDefinition
};
//# sourceMappingURL=responses.js.map
